import { makeDateFromDateRange } from './date';

const dateRange = '7日' as const;

export const defaultValues = {
  dateRange,
  ...makeDateFromDateRange(dateRange),
} as const;
